$(document).ready(function () {
  $('.home-four').slick({
    infinite: true,
    dots: true,
    autoplay: true,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          adaptiveHeight: true,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
});


$(document).ready(function () {

  $('.accordion').click(function () {
    $(this).toggleClass('active');
    $(this).siblings('.panel').slideToggle();
  });
  $('body .design_ins').trigger('click');

});

$(document).ready(function () {


  if ($('.slider-for').length) {
    var $slider = $('.slider-for')
      .on('init', function (slick) {
        $('.slider-for').fadeIn(1000);
      })
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        autoplay: false,
        dots: true,
        lazyLoad: 'ondemand',
        autoplaySpeed: 3000,
        asNavFor: '.slider-nav'
      });

    var $slider2 = $('.slider-nav')
      .on('init', function (slick) {
        $('.slider-nav').fadeIn(1000);
      })
      .slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        asNavFor: '.slider-for',
        dots: false,
        centerMode: true,
        focusOnSelect: true
      });

    //remove active class from all thumbnail slides
    $('.slider-nav .slick-slide').removeClass('slick-active');

    //set active class to first thumbnail slides
    $('.slider-nav .slick-slide').eq(0).addClass('slick-active');

    // On before slide change match active thumbnail to current slide
    $('.slider-for').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      $('.slider-nav .slick-slide').removeClass('slick-active');
      $('.slider-nav .slick-slide').eq(mySlideNumber).addClass('slick-active');
    });


    // init slider
    // require(['js-sliderWithProgressbar'], function(slider) {

    //     $('.slider-for').each(function() {

    //         me.slider = new slider($(this), options, sliderOptions, previewSliderOptions);

    //         // stop slider
    //         //me.slider.stop();

    //         // start slider
    //         //me.slider.start(index);

    //         // get reference to slick slider
    //         //me.slider.getSlick();

    //     });
    // });
    var options = {
      progressbarSelector: '.bJS_progressbar'
      , slideSelector: '.bJS_slider'
      , previewSlideSelector: '.bJS_previewSlider'
      , progressInterval: ''
      // add your own progressbar animation function to sync it i.e. with a video
      // function will be called if the current preview slider item (".b_previewItem") has the data-customprogressbar="true" property set
      , onCustomProgressbar: function ($slide, $progressbar) { }
    }

    // slick slider options
    // see: https://kenwheeler.github.io/slick/
    var sliderOptions = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay: true
    }

    // slick slider options
    // see: https://kenwheeler.github.io/slick/
    var previewSliderOptions = {
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      focusOnSelect: true,
      centerMode: true
    }
  }




});



// Mobile select transformation removed - using dropdowns instead
// $(document).ready(function() {
//   if ($(window).width() < 767) {
//     $('ul.col_filt').each(function () {
//       var list = $(this);
//       
//       // Check if already converted to avoid double conversion
//       if (list.prev('select').length > 0 || list.is(':hidden')) {
//         return;
//       }
//       
//       var select = $(document.createElement('select')).insertBefore(list);
//       
//       select.on('change', function () {
//         window.location.href = $(this).val();
//       });

//       var currentUrl = window.location.href;

//       // Get all links (both top-level and nested child links)
//       // Parent items with dropdowns use <button>, not <a>, so this will only get actual links
//       $('li a', list).each(function () {
//         // Get text content only - use native textContent to ensure no HTML
//         var linkElement = this;
//         var linkText = linkElement.textContent ? linkElement.textContent.trim() : $(linkElement).text().trim();
//         var linkHref = linkElement.href;
//         
//         // Only process if we have valid text and href
//         if (linkText && linkHref) {
//           var option = document.createElement('option');
//           option.value = linkHref;
//           option.textContent = linkText; // Use textContent instead of text() to ensure plain text
//           
//           if (linkHref === currentUrl) {
//             option.selected = true;
//           }
//           
//           select[0].appendChild(option);
//         }
//       });

//       // Hide the original list
//       list.hide();
//     });
//   }
// });



$(document).ready(function () {

  $(document).on('click', '.Quantityadd', function () {
    // $(this).prev().val(+$(this).prev().val() + 1);
    var curr_val = $(this).siblings('.cart__qty-input').val();
    // alert($(this).siblings('.cart__qty-input').val());
    var new_val = parseInt(curr_val) + 1;
    $(this).val(new_val);
  });
  $(document).on('click', '.Quantitysub', function () {
    if ($(this).next().val() > 1) {
      var curr_val = $(this).siblings('.cart__qty-input').val();
      // alert($(this).siblings('.cart__qty-input').val());
      var new_val = parseInt(curr_val) - 1;
      $(this).val(new_val);
    }
  });


});

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector('#Huratips-Loop')){
    var endlessScroll = new Ajaxinate({
      container: '#Huratips-Loop',
      pagination: '#Huratips-Pagination'
    });
  }
});





var $slide = $(".slidersdrt")
  .slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    speed: 2000,
    autoplaySpeed: 6000,
    prevArrow: $(this).siblings('.carousel-arrows').find('.arrow-left'),
    nextArrow: $(this).siblings('.carousel-arrows').find('.arrow-right'),
    autoplay: true
  })
  .on({
    beforeChange: function (event, slick, currentSlide, nextSlide) {
      $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
      $(".slick-slide", this).eq(nextSlide).addClass("slide-animation");
    },
    afterChange: function () {
      $(".preve-slide", this).removeClass("preve-slide　slide-animation");
    }
  });
$slide.find(".slick-slide").eq(0).addClass("slide-animation");


$('.slide').each(function (item) {
  $(this).slick({
    dots: false,
    infinite: false,
    speed: 1000,
    autoplaySpeed: 3000,
    autoplay: true,
    arrows: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    variableWidth: true,
    prevArrow: $(this).siblings('.carousel-arrows').find('.arrow-left'),
    nextArrow: $(this).siblings('.carousel-arrows').find('.arrow-right')
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var pageContainer = document.getElementById('PageContainer');
  var mobileHeader = document.querySelector('.site-header__mobile-nav');
  var announcementBar = document.querySelector('.announcement-bar');

  // Top offset is handled entirely by topSpacePage() via padding-top (.padding-top-space).
  // Do NOT also shift #PageContainer with `top:` here — position:relative + top duplicates
  // the offset and leaves an empty gap below the fixed header.

  if (!mobileHeader) return;

  const headerHeightForScroll = (mobileHeader.offsetHeight || 0) - 20;

  window.addEventListener('scroll', function() {
      if (window.scrollY > headerHeightForScroll) {
          mobileHeader.style.transform = 'translateY(-100%)';
      } else {
          mobileHeader.style.transform = 'translateY(0)';
      }
  });
});

function topSpacePage(isScroll) {
  const headerGroup = document.querySelector("#shopify-section-header");
  const header = headerGroup?.querySelector("header > div");
  const firstSection = document.querySelector('.drawer-page-content');
  if (!headerGroup || !header || !firstSection) return;

  const headerHeight = header.offsetHeight;
  firstSection.classList.add('padding-top-space')
  document.querySelector("body").style.setProperty('--padding-top-content', `${headerHeight}px`);
  if(isScroll){
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
}

document.addEventListener("DOMContentLoaded", function () { topSpacePage(false); });
window.addEventListener("resize", function () { topSpacePage(false); });
